import { render, staticRenderFns } from "./debugChatComponent.vue?vue&type=template&id=6a8bd896&"
import script from "./debugChatComponent.vue?vue&type=script&lang=js&"
export * from "./debugChatComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports